import { gql } from '@apollo/client'

const requestFragment = gql`
  fragment requestFragment on Market {
    request(shortId: $shortId) {
      id
      shortId
      status

      fromName
      toName
      instructions
      isGift

      createdAt
      video {
        id
        ready
        thumbnailUrl
        url(preset: VIDEO_DEFAULT)
        downloadUrl: url(preset: VIDEO_DOWNLOAD)
        mp4Url
        width
        height
        available
      }
      publicProfile {
        id
        name
        slug
        title
        description
        instagram
        defaultMarketId
        profilePicture {
          id
          avatarUrl: url(
            format: { width: 100, height: 100, fit: crop, mask: ellipse }
          )
        }
      }
      product {
        id
        slug
      }
      beenViewed
      requestType
      orderId
      customerId
    }
  }
`

export default requestFragment
